import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourceService } from 'src/app/global/services/resource.service';
import { WEB_API } from 'src/app/global/services/web-api';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { LancamentoDespesa } from '../domain/lancamento-despesa.model';
import { LancamentoDespesaSerializer } from '../serializables/lancamento-despesa.serializer';
import { Page } from '../domain/return-api.model';

@Injectable()
export class LancamentoDespesaService extends ResourceService<LancamentoDespesa> {
  static RESOURCE = 'lancamento-despesa';

  constructor(private http: HttpClient) {
    super(http, `${WEB_API}`, `${LancamentoDespesaService.RESOURCE}`, new LancamentoDespesaSerializer(LancamentoDespesa));
  }

  pageAll(queryOptions: QueryOptions): Observable<Page<LancamentoDespesa>> {
    return this.httpClient.get<Page<LancamentoDespesa>>(
      `${WEB_API}/${LancamentoDespesaService.RESOURCE}/pageable?${queryOptions.toQueryString()}`,
    );
  }

  /** Lançamentos que atendem aos filtros, sem paginação, usados na emissão do relatório. */
  relatorio(queryOptions: QueryOptions): Observable<LancamentoDespesa[]> {
    return this.httpClient.get<LancamentoDespesa[]>(
      `${WEB_API}/${LancamentoDespesaService.RESOURCE}/relatorio?${queryOptions.toQueryString(false)}`,
    );
  }

  getValorTotal(queryOptions: QueryOptions): Observable<number> {
    return this.httpClient.get<number>(
      `${WEB_API}/${LancamentoDespesaService.RESOURCE}/totalizador?${queryOptions.toQueryString(false)}`,
    );
  }

  pagar(lancamento: LancamentoDespesa, dataPagamento: Date): Observable<LancamentoDespesa> {
    const data = dataPagamento ? `?dataPagamento=${dataPagamento.getTime()}` : '';
    return this.httpClient.put<LancamentoDespesa>(
      `${WEB_API}/${LancamentoDespesaService.RESOURCE}/${lancamento.id}/pagar${data}`,
      null,
    );
  }

  cancelar(lancamento: LancamentoDespesa): Observable<LancamentoDespesa> {
    return this.httpClient.put<LancamentoDespesa>(
      `${WEB_API}/${LancamentoDespesaService.RESOURCE}/${lancamento.id}/cancelar`,
      null,
    );
  }
}
